import { apiGet } from '../../api'

export const get_all_curriculums = query => {
  return apiGet({
    endpoint: `curriculums/all_curriculums`
  })
}
